// Shared palette for the basemap (style/layers/) and the QA trail overlay
// (js/styleGenerator.js).

export const BACKGROUND_COLOR = "hsl(40, 48%, 90%)";
export const HALO_COLOR = "hsl(40, 48%, 96%)";

export const WATER_FILL_COLOR = "#cbe1f0";
export const WATER_LINE_COLOR = "#afd1e8";
export const WATER_LABEL_COLOR = "#4590c1";

export const GLACIER_FILL_COLOR = "#f4f9fc";
export const GLACIER_LINE_COLOR = "#c8daef";

// Feature colors, used both for basemap POIs and for QA overlay lines
export const TRAIL_COLOR = "#4f2e28";
export const NATURAL_COLOR = "#005908";
export const WATER_COLOR = "#003b93";
export const LABEL_COLOR = "#333";
export const LABEL_HALO_COLOR = "#ffffff";

// QA overlay only
export const FERRY_COLOR = "#009FBE";
export const NOACCESS_TRAIL_COLOR = "#cc9e7e";
export const DISALLOWED_WATER_COLOR = "#a6b2c4";
export const SPECIFIED_COLOR = "#007f79";
export const UNSPECIFIED_COLOR = "#c100cc";
export const TIDAL_COLOR = "#0041e5";
export const SELECTION_COLOR = "yellow";
